(function () {
  var END = '2026-11-19T00:00:00+01:00';
  var target = Date.parse(END);
  if (!target) return;

  function teardown() {
    document.querySelectorAll('.ff-promo--gta').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.ff-gta--ticket').forEach(function (el) {
      var sec = el.closest('.shopify-section');
      (sec || el).remove();
    });
    var campaign = document.querySelector('.ff-gta--campaign');
    var view = /(?:^|[?&])view=ps5-gta(?:&|$)/.test(location.search);
    var handle = /\/pages\/(ps5-fit-gta|ps5-gta|gta6)\/?$/.test(location.pathname);
    if (campaign || view || handle) {
      location.replace('/pages/konsolen-reparatur');
    }
  }

  if (Date.now() >= target) {
    teardown();
    return;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function paint(node, remain) {
    var days = Math.floor(remain / 86400000);
    var hours = Math.floor((remain % 86400000) / 3600000);
    var mins = Math.floor((remain % 3600000) / 60000);
    var secs = Math.floor((remain % 60000) / 1000);
    var map = { d: pad(days), h: pad(hours), m: pad(mins), s: pad(secs) };
    node.querySelectorAll('[data-ff-gta-unit]').forEach(function (el) {
      var key = el.getAttribute('data-ff-gta-unit');
      if (map[key] != null) el.textContent = map[key];
    });
    var live = node.querySelector('[data-ff-gta-live]');
    if (live) {
      live.textContent = days + (days === 1 ? ' Tag' : ' Tage') + ' bis zum Start – HDMI, Hitze und Drift jetzt klären.';
    }
  }

  function tick() {
    var now = Date.now();
    var remain = target - now;
    if (remain <= 0) {
      teardown();
      return;
    }
    document.querySelectorAll('[data-ff-gta-count]').forEach(function (node) {
      paint(node, remain);
    });
  }

  tick();
  setInterval(tick, 1000);
})();
